var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "url(#paint0_linear_2919_23770)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66801 3.37765H8.03602C8.69555 3.37765 9.23083 3.90589 9.23083 4.55676V4.73599H2.76929V4.55676C2.76929 3.90589 3.30456 3.37765 3.9641 3.37765H4.3321V3.00505C4.3321 2.87299 4.43724 2.76923 4.57106 2.76923C4.70488 2.76923 4.81002 2.87299 4.81002 3.00505V3.37765H7.19009V3.00505C7.19009 2.87299 7.29523 2.76923 7.42905 2.76923C7.56287 2.76923 7.66801 2.87299 7.66801 3.00505V3.37765ZM3.9641 9.23078C3.30456 9.23078 2.76929 8.70254 2.76929 8.05167V5.20765H9.23083V8.05167C9.23083 8.70254 8.69555 9.23078 8.03602 9.23078H3.9641ZM5.0681 6.74521C4.98686 6.64617 4.8387 6.62258 4.73356 6.70276L4.72878 6.69333C4.62363 6.77351 4.60452 6.91972 4.68576 7.02348L4.98686 7.41495C5.10634 7.57531 5.29273 7.66492 5.49346 7.66492H5.51257C5.63205 7.6602 5.74198 7.62247 5.83756 7.56116C5.94271 7.62719 6.05741 7.66492 6.18167 7.66492H6.20078C6.40629 7.6602 6.59746 7.55644 6.71216 7.38665L7.31435 6.49524C7.38604 6.38676 7.35736 6.24055 7.24744 6.1698C7.24266 6.16509 7.23788 6.16509 7.23788 6.16509C7.13274 6.09434 6.98936 6.12264 6.91767 6.23112L6.31549 7.12253C6.28681 7.16498 6.23902 7.19327 6.18645 7.19327C6.17689 7.19327 6.15777 7.18856 6.15777 7.18856L6.62614 6.49524C6.69783 6.38676 6.66915 6.24055 6.55923 6.1698C6.55445 6.16509 6.54967 6.16509 6.54967 6.16509C6.44453 6.09434 6.30115 6.12264 6.22946 6.23112L5.82322 6.83482L5.75154 6.74049C5.67029 6.64145 5.52213 6.61787 5.41699 6.69805C5.31185 6.77823 5.29273 6.92444 5.37398 7.0282L5.50302 7.19799C5.45044 7.20271 5.40265 7.17912 5.37398 7.13668L5.0681 6.74521Z",
    fill: "url(#paint1_linear_2919_23770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_23770",
    x1: 0,
    y1: 0,
    x2: 14.2789,
    y2: 4.14004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13AE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2919_23770",
    x1: 4.06509,
    y1: -2.24928,
    x2: 10.5026,
    y2: -0.993232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ee57a656f8937caff924c7f4cc344c14.svg";
export { ForwardRef as ReactComponent };